/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { UserContext } from '../../context/user-context';

function HighlightsReel({ video }) {
  const { playVideo } = useContext(UserContext);
  const niceDate = moment(video?.date).format('D MMMM');

  if (!video) {
    return null;
  }

  const onClick = () => {
    playVideo(video);
  };

  return (
    <div className="video__item text-decoration-none" onClick={onClick}>
      <img src={video?.thumbnail} alt="" />
      <div className="video__info">
        <p className="text-small text-color-primary-yellow text-uppercase fw-bold">
          {niceDate}
        </p>
        <p className="heading-h5 text-transform-none">{video?.description}</p>
      </div>
    </div>
  );
}

export default HighlightsReel;
